import Navbar from "../components/Navbar";
import SecondNavbar from "../components/SecondNavbar";
import Footer from "../components/Footer";
import ProtectedWrapper from "../components/ProtectedWrapper";
import ReportContent from "./ReportContent";

const Report = () => {
  return (
    <>
      <Navbar />
      <SecondNavbar />

      <ProtectedWrapper isLoggedIn={!!localStorage.getItem("token")}>
        <ReportContent />
      </ProtectedWrapper>

      <Footer />
    </>
  
  );
};

export default Report;